// whatsapp.service.ts
import { Injectable, inject, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { io, Socket } from 'socket.io-client';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { GlobalVariable } from 'src/app/global';

export interface WhatsappStatus {
  status: 'desconectado' | 'conectando' | 'escaneando' | 'conectado' | 'reconectando';
  qr: string | null;
}

export interface WhatsappMessage {
  sender: string;
  text: string;
  timestamp: number;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class WhatsappService {
  private ngZone = inject(NgZone); // 👈 Inyecta NgZone
  private http = inject(HttpClient);
  private socket: Socket | null = null;
  private readonly SERVER_URL = GlobalVariable.SERVER_URL; // Ajusta con tu URL de Node.js

  // Estados Reactivos para los componentes
  private statusSubject = new BehaviorSubject<WhatsappStatus>({ status: 'desconectado', qr: null });
  public status$ = this.statusSubject.asObservable();

  private messagesSubject = new Subject<WhatsappMessage>();
  public messages$ = this.messagesSubject.asObservable();

  /**
   * Conecta al WebSocket de la empresa y se une a su sala privada
   */
  conectarEmpresaSocket(empresaId: string): void {
    // Si ya había una conexión activa, la cerramos antes de abrir una nueva (por si cambia de empresa en el panel)
    if (this.socket) {
      this.socket.disconnect();
    }

    this.socket = io(this.SERVER_URL);

    this.socket.on('connect', () => {
      console.log(`🔌 Conectado al WebSocket. Uniéndose a sala: empresa_${empresaId}`);
      this.socket?.emit('join_session', 'empresa_' + empresaId);
    });

    // Escuchamos cambios de estado y código QR
    this.socket.on('status_update', (data: WhatsappStatus) => {
      console.log('📬 [SOCKET CLIENT] Recibido status_update:', data);
      // 🚀 Forzamos a Angular a procesar la actualización dentro de su ciclo de vida
      this.ngZone.run(() => {
        this.statusSubject.next(data);
      });
    });

    // Escuchamos mensajes entrantes en tiempo real
    this.socket.on('new_message', (message: WhatsappMessage) => {
      this.messagesSubject.next(message);
    });

    this.socket.on('disconnect', () => {
      this.statusSubject.next({ status: 'desconectado', qr: null });
    });
  }

  /**
   * Petición HTTP para inicializar Baileys en el servidor para esta empresa
   */
  solicitarConexionExpress(empresaId: string): Observable<any> {
    return this.http.post(`${GlobalVariable.API_SERVER_URL}conexion-cliente-whatsapp`, { id_empresa:empresaId });
  }

  /**
   * Petición HTTP para cerrar la sesión y borrar credenciales
   */
  solicitarDesvinculacionExpress(empresaId: string): Observable<any> {
    return this.http.delete(`${GlobalVariable.API_SERVER_URL}desconectar-cliente-whatsapp/${empresaId}`);
  }

  /**
   * Desconecta los sockets al destruir o desloguear al usuario
   */
  desconectarSocket(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}